<template>
	<div ref="popupContainer">
		<!--ACHATS POPUP-->
		<!-- <vs-popup :active.sync="showPurchasePopup" title="Achats">
		<div>
		<vs-table :data="allPurchases" class="mt-4 w-full" noDataText="">
    <template slot="thead">
      <vs-th></vs-th>
      <vs-th class="white-txt"><div class="w-full text-right">{{ getMonthFrench(today.getMonth()-2).toUpperCase() + " " + getYearFromMonth(today.getMonth() - 2) }}</div></vs-th>
      <vs-th class="white-txt tr2"><div class="w-full text-right" style="padding-right: 20px;">{{ getMonthFrench(today.getMonth()-1).toUpperCase() + " " + getYearFromMonth(today.getMonth() - 1) }}</div></vs-th>
      <vs-th class="white-txt" style="width: 140px;"><div class="layer-blue"><div></div></div><div class="w-full text-right text-white" style="padding-right: 20px; z-index: 998;">{{ getMonthFrench(today.getMonth()).toUpperCase() + " " + getYearFromMonth(today.getMonth()) }}</div></vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr class="noHover" style="background: transparent;">
        <vs-td style="font-weight:500; padding-left: 20px !important;"><div style="width: 50px; white-space: nowrap;"><span>Total HT<br/></span><span style="color: #08B0B9;">À refacturer</span></div></vs-td>
        <vs-td class="text-right" style="font-weight:500; padding-right: 12px;">{{ lastLastMonthSum }}€<br/><span style="color: #08B0B9;">{{ lastLastMonthRefac }}€</span></vs-td>
        <vs-td class="text-right tr2" style="font-weight:500; padding-right: 12px;"><div style="padding-right: 20px;">{{ lastMonthSum }}€<br/><span style="color: #08B0B9;">{{ lastMonthRefac }}€</span></div></vs-td>
        <vs-td class="text-right" style="padding-right: 32px;"><div style="color: white; position: relative; z-index: 999;">{{ actualMonthSum }}€<br/><span style="color: #08B0B9;">{{ actualMonthRefac }}€</span></div></vs-td>
      </vs-tr>
    </template>
  </vs-table>
      </div>
    </vs-popup> -->
		<!--ACHATS POPUP-->
		<!--DELETE PRESTATAIRE -->
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir valider la supression du prestataire ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<!--DELETE PRESTATAIRE -->
		<vs-table
			:data="providersList"
			stripe
			:max-height="tableHeight + 'px'"
			:key="refresh"
		>
			<template slot="thead">
				<vs-th class="th-sticky pdl0">Société</vs-th>
				<vs-th class="th-sticky"
					><div class="w-full text-center">Site web</div></vs-th
				>
				<vs-th class="th-sticky pdl0">Note</vs-th>
				<vs-th class="th-sticky pdl0">Commentaire</vs-th>
				<vs-th class="th-sticky">Expertises</vs-th>
				<vs-th class="th-sticky">Tags</vs-th>
				<vs-th class="th-sticky">Type</vs-th>
				<vs-th class="th-sticky">Statut</vs-th>
				<vs-th class="th-sticky"></vs-th>
				<vs-th class="th-sticky"></vs-th>
				<vs-th class="th-sticky" v-if="$acl.check('sadmin')"></vs-th>
			</template>

			<template>
				<vs-tr :key="index" v-for="(provider, index) in providersList">
					<!-- <vs-td v-show="false">
				{{setRowNum(data.length)}}
			</vs-td> -->

					<vs-td :data="provider.society">{{ provider.society }}</vs-td>
					<vs-td :data="provider.website" v-if="provider.website" class="pdl0">
						<vx-tooltip
							:text="provider.website"
							position="top"
							class="flex center"
						>
							<vs-button
								color="primary"
								size="large"
								type="flat"
								icon-pack="feather"
								icon="icon-link-2"
								:href="provider.website"
								target="_blank"
							></vs-button>
						</vx-tooltip>
					</vs-td>
					<vs-td v-else> </vs-td>
					<vs-td :data="provider.rate">
						<star-rating
							:show-rating="false"
							:star-size="20"
							:read-only="true"
							:rtl="$vs.rtl"
							:rating="provider.rate"
							active-color="#35e9fd"
						></star-rating>
					</vs-td>
					<vs-td :data="provider.commentary">{{ provider.commentary }}</vs-td>
					<vs-td :id="'c' + provider.id">
						<vs-chip
							v-for="service_name in provider.service_name_list"
							:key="service_name"
							>{{ service_name }}</vs-chip
						>
					</vs-td>
					<vs-td :id="'t' + provider.id">
						<vs-chip
							v-for="tag in provider.tags"
							:key="tag.name"
							color="rgb(8,176,185)"
							>{{ tag.name }}</vs-chip
						>
					</vs-td>
					<vs-td :id="'d' + provider.id">
						<vs-chip v-if="provider.type_name" :key="provider.type_name">{{
							provider.type_name
						}}</vs-chip>
					</vs-td>
					<vs-td :id="'e' + provider.id">
						<vs-chip
							style="
								width: 80px;
								margin-left: 10px;
								border-radius: 6px;
								padding-top: 2px;
							"
							:color="getProviderStatusColor(provider.status)"
							>{{ getStatusName(provider) }}</vs-chip
						>
					</vs-td>
					<vs-td style="text-align: center">
						<vx-tooltip
							text="View"
							position="top"
							style="text-align: -webkit-center; margin-right: 0 !important"
						>
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-eye"
								@click="showPurchase(provider)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
					<vs-td style="text-align: center">
						<vx-tooltip
							text="Modifier"
							position="top"
							style="text-align: -webkit-center; margin-right: 0 !important"
						>
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-edit"
								@click="updateProvider(provider)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
					<vs-td v-if="$acl.check('sadmin')" style="text-align: center">
						<vx-tooltip
							text="Effacer"
							position="top"
							style="text-align: -webkit-center; margin-right: 0 !important"
						>
							<vs-button
								size="large"
								color="danger"
								type="flat"
								icon-pack="feather"
								icon="icon-trash-2"
								@click="displayValidationPopup(provider)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import store from "@/store/store";
import StarRating from "vue-star-rating";
import utilsMixin from "@/mixins/utilsMixin.js";
import ProvidersExpertiseChips from "@/components/chips/ProvidersExpertiseChips";
import ProviderPurchasePopup from "@/components/popups/ProviderPurchasePopup.vue";
import Provider from "@/entities/Provider";

export default {
	name: "ProvidersTable",
	props: {
		purchases: Array,
		providers: Array,
		services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertor],
	components: {
		StarRating,
		ProviderPurchasePopup,

		// ProvidersExpertiseChips
	},
	data() {
		return {
			allPurchases: [],
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null, // catching api error message
			showProviderPopup: false,
			selectedProvider: null,
			showValidationPopup: false,
			showPurchasePopup: false,
			tagsList: {},
			providersList: [],
			displayedPurchasesFull: [],
			statusList: [
				{
					id: 2,
					name: "In Actif",
				},
				{
					id: 1,
					name: "Actif",
				},
				{ id: 0, name: "Non renseigné" },
			],
			refresh: "tag",
		};
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight;
		},
	},
	created() {
		//console.log("PURCHASES TABLE", this.$props.purchases);
	},
	mounted() {
		store.dispatch(
			"updateTableHeight",
			this.windowHeigth -
				this.horizentalNavBarHeight -
				this.filterCardHeight -
				0.1 * this.windowHeigth
		);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch(
					"updateTableHeight",
					this.windowHeigth -
						this.horizentalNavBarHeight -
						this.filterCardHeight -
						0.1 * this.windowHeigth
				);
			});
		});
	},
	watch: {
		isFilterDown: function () {
			store.dispatch(
				"updateFilterCardHeight",
				document.getElementById("fliterCard").clientHeight
			);
			store.dispatch(
				"updateTableHeight",
				this.windowHeigth -
					this.horizentalNavBarHeight -
					this.filterCardHeight -
					0.1 * this.windowHeigth
			);
		},
		providers: function (data) {
			this.providersList = data;
			if (data.length == 0) {
				this.setRowNum(0);
			}
			this.getActivityDomain(this.providersList);
		},
	},

	methods: {
		getStatusName(row) {
			let status = "-";
			try {
				status = this.statusList.find((ele) => ele.id == row.status)["name"];
			} catch (e) {}
			return status;
		},
		setRowNum(len) {
			store.dispatch("setRowNum", len);
		},

		async getActivityDomain(providers) {
			for (let provider of providers) {
				await this.$http
					.get(this.apiUrl + "tags/provider/" + provider.id)
					.then((res) => {
						let tmp = res.data;
						for (let tag of tmp) {
							tag["name"] = tag.tag_name;
							delete tag.tag_name;
						}
						provider["tags"] = tmp;
					})
					.catch((err) => console.log(err));
			}
			this.refresh = "tag" + Math.random();
		},
		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		getServiceIdToName(service_id) {
			let service_name = "";
			let service = this.services.find((service) => service.id == service_id);
			service_name = service.name;
			return service_name;
		},

		/**
		 * Create jsx chips to display
		 * @param {Array} service_id_list - List of service ids to create chip for
		 * @return {String} - JSX of services' chips
		 */
		createChips(providers) {
			setTimeout(() => {
				let providersList = providers;
				for (let provider of providersList) {
					//Instancie la class ProvidersExpertiseChips pour mount sur la balise div principale
					let ComponentClass = Vue.extend(ProvidersExpertiseChips);
					let providersExpertiseChips = new ComponentClass({
						propsData: {
							services: this.services,
							service_id_list: provider.service_id_list,
						},
					});
					let id = "#c" + provider.id;
					providersExpertiseChips.$mount(id);
				}
			}, 500);
		},

		deleteProvider(provider) {
			let providerToDelete = new Provider(provider);
			providerToDelete.delete((err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						this.$store.dispatch("getAllProviders");
						this.$store.dispatch("getAllServices");
						this.$emit("delete-line", provider);
					}
			});
		},

		updateProvider(provider) {
			this.$emit("modify-provider", provider);
		},
		showPurchase(provider) {
			//console.log(provider);
			this.$router.push({
				name: "purchases",
				params: { contract_id: provider.id },
			});
		},

		displayValidationPopup(provider) {
			this.selectedProvider = provider;
			this.showValidationPopup = true;
		},

		accept() {
			this.deleteProvider(this.selectedProvider);
			this.showValidationPopup = false;
		},

		decline() {
			this.selectedProvider = null;
			this.showValidationPopup = false;
		},
	},
};
</script>

<style scoped>
.center {
	justify-content: center;
}
</style>
